import { INovaGuiaRecolhimento } from 'interfaces/IGuiaRecolhimento';

const validarCampoTexto = (value?: string | number): boolean => {
  return value === undefined || value === null || value === '';
};

const validarMesAno = (value?: number): boolean => {
  return value === undefined || value === null || value === 0;
};

const validateCampoNumero = (value?: number): boolean => {
  return value === undefined || value === null || value === -1;
};

const retornarCamposObrigatorios = (isEdicaoDadosRecolhimento: boolean) => {
  type ValidacaoCampo = {
    field: keyof INovaGuiaRecolhimento;
    label: string;
    validate?: (value?: any) => boolean;
  };

  const CAMPOS_OBRIGATORIOS: ValidacaoCampo[] = [
    { field: 'competenciaMes', label: 'Mês', validate: validarMesAno },
    { field: 'competenciaAno', label: 'Ano', validate: validarMesAno },
    { field: 'numeroProcesso', label: 'Processo', validate: validarCampoTexto },
    { field: 'municipio', label: 'Município', validate: validateCampoNumero },
    { field: 'substancia', label: 'Substância', validate: validarCampoTexto },
    { field: 'tipoRelacao', label: 'Tipo de Vínculo', validate: validateCampoNumero },
  ];

  const CAMPOS_OBRIGATORIOS_EDICAO: ValidacaoCampo[] = [
    { field: 'tipoRelacao', label: 'Tipo de Vínculo', validate: validateCampoNumero },
  ];

  return isEdicaoDadosRecolhimento ? CAMPOS_OBRIGATORIOS_EDICAO : CAMPOS_OBRIGATORIOS;
};

const validarCamposObrigatorios = (formValues: INovaGuiaRecolhimento, isEdicaoDadosRecolhimento: boolean) => {
  const camposObrigatorios = retornarCamposObrigatorios(isEdicaoDadosRecolhimento);

  const camposInvalidos = [];

  for (const campo of camposObrigatorios) {
    const testeValidacao = campo.validate || validarCampoTexto;

    if (testeValidacao(formValues[campo.field])) {
      camposInvalidos.push(campo.label);
    }
  }

  if (camposInvalidos.length === camposObrigatorios.length) {
    return 'Por favor, preencha corretamente todos os campos';
  } else if (camposInvalidos.length >= 2) {
    return `Por favor, preencha corretamente os campos "${camposInvalidos[0]}" e "${camposInvalidos[1]}"`;
  } else if (camposInvalidos.length === 1) {
    return `Por favor, preencha corretamente o campo "${camposInvalidos[0]}"`;
  } else {
    return '';
  }
};

export const validarDadosRecolhimento = (formValues: INovaGuiaRecolhimento, isEdicaoDadosRecolhimento: boolean) => {
  return validarCamposObrigatorios(formValues, isEdicaoDadosRecolhimento);
};
